module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/ko_2-c9b5cf453dbe97ac412388dd9cecc9a8.jpg";